import { RangoProcesoDivision } from '@interfaces/firestore-documents.interfaces';
import { Chip } from '@mui/material';
import clsx from 'clsx';
import useAGWRangesTableStyles from './AGWRangesTable.styles';

interface Props {
	data: RangoProcesoDivision[];
}

const AGWRangesTable: React.FC<Props> = ({ data }) => {
	const classes = useAGWRangesTableStyles();

	return (
		<div className={classes.container}>
			<table className={classes.root}>
				<thead>
					<tr>
						<th>ID</th>
						<th>Prefijo</th>
						<th>Inicial</th>
						<th>Final</th>
					</tr>
				</thead>
				<tbody>
					{data.map((range, index) => (
						<tr
							className={clsx({
								disabled: range.terminado || !range.en_uso,
							})}
							id={`${range.id_proceso}-${range.id_rango}`}
							key={`${range.id_proceso}-${range.id_rango}-${index}`}
						>
							<td>{range.id_rango}</td>
							<td>
								<Chip label={range.prefijo_consecutivo} variant="outlined" />
							</td>
							<td>
								<Chip label={range.consecutivo_desde} variant="outlined" />
							</td>
							<td>
								<Chip label={range.consecutivo_hasta} variant="outlined" />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default AGWRangesTable;
